var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorPaymentCard(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0h44a4 4 0 014 4v27a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z",
    fill: "#F8AC95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 5c-6.625 0-12 5.375-12 12s5.375 12 12 12 12-5.375 12-12S32.625 5 26 5zm2 19.484c0 .282-.219.516-.484.516h-3a.52.52 0 01-.516-.516v-2.968a.52.52 0 01.516-.516h3c.265 0 .484.234.484.516v2.968zm-.031-5.375c-.016.22-.25.391-.532.391h-2.89c-.297 0-.531-.172-.531-.39l-.266-9.704c0-.11.047-.219.156-.281A.602.602 0 0124.281 9h3.438c.14 0 .281.047.375.125.11.063.156.172.156.281l-.281 9.703z",
    fill: "#A83E1D"
  })));
}

export default SvgErrorPaymentCard;